export const logo_subtypes = {
  dark: 'dark',
  light: 'light',
};

export const logo_types = {
  naga: {
    value: 'naga',
    label: 'LOGOS.OTHER',
  },
};



// WEBPACK FOOTER //
// ./src/app/main/logos/constants/logos-constants.js